import React,{useState} from 'react'
import { useFormContext } from '../Context/FormContext';

const CustomCheckbox = ({handleFocus, setCategory, setIsVisible, isVisible, data, category, catId}) => {

    const [checked, setChecked] = useState(false);

    const { formData, updateFormData } = useFormContext();

    const handleChange = (e) => {
        if(isVisible){
            handleFocus()
        }
        
        console.log("Toggle ",e.target.checked)
        console.log("DATA ",`${data} ${catId}`)


        // if (e.target.checked) {
        //     if (data === "Others") {
        //         // If "Others" is selected, unselect all other checkboxes
        //         setCategory([parseInt(catId)]); // Select only the "Others" category
        //         setIsVisible(true);
        //         updateFormData({ category_other: '' });
        //     } else {
        //         // If another category is selected, add it to the selected categories
        //         setCategory((prevCategories) => [...prevCategories, parseInt(catId)]);
        //         setIsVisible(false);
        //         delete formData.category_other; // Remove category_other property
        //     }
        // } else {
        //     // If the checkbox is unchecked, remove the category from the selected categories
        //     setCategory(category?.filter((item) => item !== parseInt(catId)));
        //     if (data === "Others") {
        //         setIsVisible(false);
        //         delete formData.category_other; // Remove category_other property
        //     }
        // }

        // setChecked(!checked)

        const isChecked = e.target.checked;

        // // Clear the checked state of all other checkboxes if "Others" is selected
        // if (isChecked && data === "Others") {
        //     // Uncheck all other checkboxes by setting their checked state to false
        //     const otherCheckboxes = document.querySelectorAll('input[type="checkbox"]:not([value="Others"])');
        //     otherCheckboxes.forEach(checkbox => {
        //         console.log("Other checkboxes", checkbox.checked)
        //         checkbox.checked = false;
        //     });
            
        // }

        setChecked(isChecked);

        // // Update the form data based on the checkbox state
        // if (isChecked) {
        //     if (data === "Others") {
        //         // If "Others" is selected, unselect all other checkboxes
        //         setCategory([parseInt(catId)]);
        //         setIsVisible(true);
        //         updateFormData({ category_other: '' });
        //     } else {
        //         // If another category is selected, add it to the selected categories
        //         setCategory((prevCategories) => [...prevCategories, parseInt(catId)]);
        //         setIsVisible(false);
        //         delete formData.category_other;
        //     }
        // } else {
        //     // If the checkbox is unchecked, remove the category from the selected categories
        //     setCategory(category?.filter((item) => item !== parseInt(catId)));
        //     if (data === "Others") {
        //         setIsVisible(false);
        //         delete formData.category_other;
        //     }
        // }

        // If the checkbox is checked
        if (isChecked) {
            // If "Others" is selected, unselect all other checkboxes
            // if (data === "Others") {
            //     const otherCheckboxes = document.querySelectorAll('input[type="checkbox"]:not([value="Others"])');
            //     otherCheckboxes.forEach(checkbox => {
            //         checkbox.checked = false;
            //     });
            // } else {
            //     // If another category is selected, unselect the "Others" checkbox
            //     const othersCheckbox = document.querySelector('input[type="checkbox"][value="Others"]');
            //     if (othersCheckbox) {
            //         othersCheckbox.checked = false;
            //     }
            // }

            // Update the checked state of the current checkbox
            setChecked(true);

            // Update the form data based on the checkbox state
            if (data === "Others") {
                // setCategory([parseInt(catId)]);
                setCategory((prevCategories) => [...prevCategories, parseInt(catId)]);
                setIsVisible(true);
                updateFormData({ category_other: '' });
            } else {
                // setCategory([parseInt(catId)]);
                setCategory((prevCategories) => [...prevCategories, parseInt(catId)]);
                // setIsVisible(false);
                // delete formData.category_other;
            }

        } else {
        // If the checkbox is unchecked, remove the category from the selected categories
        setCategory([]);
        setIsVisible(false);

        // Update the checked state of the current checkbox
        // setChecked(false);

        // Update the form data based on the checkbox state
        if (data === "Others") {
            delete formData.category_other;
        }
        }

      

    }

  return (

    <div>

        <div className="form-check">

            <label className="customcheck">

                <input type="checkbox" data-category={data} value={data} defaultValue={formData?.category} onChange={handleChange} />

                <span className="checkmark"></span>

            </label>

        </div>

    </div>

  )

}

export default CustomCheckbox